<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="90%" top="4vh" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button
              v-if="isAuth('purchase:purchaseOrder:confirm') && String(dataForm.orderStatus) !== '2'"
              type="primary"
              size="small"
              :disabled="actionLoading"
              @click="confirmHandle"
            >确认</el-button>
            <el-button
              v-if="canUnconfirmOrder"
              type="primary"
              size="small"
              :disabled="actionLoading"
              @click="unconfirmHandle"
            >反确认</el-button>
            <el-button
              v-if="isAuth('purchase:purchaseOrder:update')"
              type="primary"
              size="small"
              :disabled="String(dataForm.orderStatus) === '2' || actionLoading"
              @click="readonly = false"
            >修改</el-button>
            <el-button
              v-if="isAuth('purchase:purchaseOrder:delete')"
              type="primary"
              size="small"
              :disabled="String(dataForm.orderStatus) === '2' || actionLoading"
              @click="deleteHandle"
            >删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>

    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="90px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="采购单号" prop="purchaseOrderCode">
            <el-input v-model="dataForm.purchaseOrderCode" :disabled="formReadonly || codeReadonly || !!dataForm.purchaseOrderId" :placeholder="codeReadonly && !dataForm.purchaseOrderId ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订购日期" prop="orderDate">
            <el-date-picker v-model="dataForm.orderDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商" prop="supplierId">
            <el-input v-model="dataForm.supplierName" readonly placeholder="请选择供应商">
              <el-button v-if="!formReadonly" slot="append" @click="supplierSelectorVisible = true">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="状态">
            <el-tag v-if="String(dataForm.orderStatus) === '2'" type="success" size="small">已确认</el-tag>
            <el-tag v-else type="info" size="small">开立</el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="dataForm.remark" :disabled="formReadonly" />
      </el-form-item>
    </el-form>

    <div v-if="!formReadonly" style="margin-bottom:10px;">
      <el-button type="primary" size="small" @click="materialSelectorVisible = true">选择物料</el-button>
      <el-button type="primary" size="small" @click="addLine">新增行</el-button>
    </div>

    <el-table :key="tableKey" border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="materialCode" label="产品编码" min-width="130" header-align="center" align="left">
        <template slot-scope="scope">
          <el-input v-model="scope.row.materialCode" size="small" :disabled="formReadonly" placeholder="产品编码" @blur="fillMaterialByCode(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="产品名称" min-width="140" header-align="center" align="left" />
      <el-table-column prop="specs" label="规格" min-width="100" header-align="center" align="left" />
      <el-table-column prop="quantity" label="订购数量" width="150" header-align="center" align="right">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.quantity"
            size="small"
            :disabled="formReadonly"
            :min="getLineQuantityMin(scope.row)"
            :precision="2"
            controls-position="right"
            style="width:100%"
            @change="onLineQuantityChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column v-if="showReceivedQtyCol" prop="receivedQuantity" label="已入库" width="90" header-align="center" align="right">
        <template slot-scope="scope">{{ formatQty(scope.row.receivedQuantity) }}</template>
      </el-table-column>
      <el-table-column prop="price" label="含税单价" width="150" header-align="center" align="right">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.price" size="small" :disabled="formReadonly" :min="0" :precision="2" controls-position="right" style="width:100%" @change="calcLineAmount(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="tax" label="税点" width="110" header-align="center" align="center">
        <template slot-scope="scope">
          <el-select v-model="scope.row.tax" size="small" :disabled="formReadonly" placeholder="税点" style="width:100%">
            <el-option v-if="hasLegacyTax(scope.row.tax)" :label="String(scope.row.tax)" :value="Number(scope.row.tax)" />
            <el-option
              v-for="item in taxList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="Number(item.dictValue)"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryDate" label="交货日期" width="150" header-align="center" align="center">
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.deliveryDate"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            style="width:100%"
            :disabled="formReadonly"
            placeholder="交货日期"
          />
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" header-align="center" align="left">
        <template slot-scope="scope">
          <el-input v-model="scope.row.remark" size="small" :disabled="formReadonly" placeholder="备注" maxlength="500" />
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="行金额" width="110" header-align="center" align="right">
        <template slot-scope="scope">{{ formatAmount(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="usableQuantity" label="可用库存" width="110" header-align="center" align="right">
        <template slot-scope="scope">
          <span :class="{ 'purchases-order-qty-warn': isLineUsableInsufficient(scope.row) }">
            {{ formatUsableQty(scope.row.usableQuantity) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="!formReadonly" label="操作" width="70" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            :disabled="!canDeleteLine(scope.row)"
            @click="removeLine(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>

    <supplier-selector :visible.sync="supplierSelectorVisible" @select="chooseSupplier" />
    <material-selector :visible.sync="materialSelectorVisible" :multiple="true" @select-multiple="chooseMaterials" />
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import { getMaterialByCode } from '../../api/base/material'
import MaterialSelector from '../../components/MaterialSelector.vue'
import SupplierSelector from '../../components/SupplierSelector.vue'

function blankForm() {
  return {
    purchaseOrderId: '',
    purchaseOrderCode: '',
    orderDate: '',
    supplierId: '',
    supplierName: '',
    orderStatus: '0',
    remark: '',
    lines: []
  }
}

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

export default {
  name: 'PurchaseOrderAddOrUpdate',
  components: { MaterialSelector, SupplierSelector },
  data() {
    return {
      visible: false,
      readonly: false,
      submitLoading: false,
      actionLoading: false,
      codeReadonly: false,
      tableKey: 0,
      supplierSelectorVisible: false,
      materialSelectorVisible: false,
      taxList: [],
      originalTaxes: {},
      permCodes: [],
      dataForm: blankForm(),
      dataRule: {
        purchaseOrderCode: [{
          validator: (rule, value, callback) => {
            if (this.codeReadonly) { callback(); return }
            if (!value || !String(value).trim()) callback(new Error('采购单号不能为空'))
            else callback()
          },
          trigger: 'blur'
        }],
        orderDate: [{ required: true, message: '订购日期不能为空', trigger: 'change' }],
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() {
      return this.readonly || String(this.dataForm.orderStatus) === '2'
    },
    formRules() {
      return this.formReadonly ? {} : this.dataRule
    },
    dialogTitle() {
      if (this.readonly) return '查看采购订单'
      return this.dataForm.purchaseOrderId ? '修改采购订单' : '新增采购订单'
    },
    isEditMode() {
      return !!this.dataForm.purchaseOrderId && !this.readonly
    },
    showReceivedQtyCol() {
      return !!this.dataForm.purchaseOrderId
    },
    showViewToolbar() {
      return this.readonly && !!this.dataForm.purchaseOrderId
    },
    canUnconfirmOrder() {
      if (!this.dataForm.purchaseOrderId || String(this.dataForm.orderStatus) !== '2') return false
      return this.isAuth('purchase:purchaseOrder:unconfirm') || this.isAuth('purchase:purchaseOrder:confirm')
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.submitLoading = false
      this.actionLoading = false
      this.codeReadonly = !!id
      this.tableKey += 1
      this.dataForm = blankForm()
      this.originalTaxes = {}
      this.dataForm.orderDate = today()
      this.loadTaxList()
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
        if (!id) this.resolveCode()
        if (id) this.loadDetail(id)
      })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'purchaseOrder' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.purchaseOrderCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('purchaseOrderCode')
        })
      }).catch(() => {})
    },
    loadTaxList() {
      return request.get('/sys/dicts', { params: { dictType: 'TAX' } }).then(res => {
        this.taxList = (res.data || []).map(item => ({
          ...item,
          dictValue: item.dictValue != null ? String(item.dictValue) : String(item.itemCode || item.dictItemId || ''),
          dictLabel: item.dictLabel || item.itemName || item.dictValue
        }))
      }).catch(() => {})
    },
    hasLegacyTax(value) {
      return value != null && value !== '' && !this.taxList.some(item => Number(item.dictValue) === Number(value))
    },
    materialTax(value) {
      if (value == null || value === '') return value
      const tax = Number(value)
      if (!Number.isFinite(tax)) return value
      const values = this.taxList.map(item => Number(item.dictValue))
      if (values.includes(tax)) return tax
      // 历史物料用 13 表示 13%，当前字典用 0.13。
      if (tax > 1 && values.includes(tax / 100)) return tax / 100
      return tax
    },
    loadDetail(id) {
      request.get('/purchase/purchaseOrder/info/' + id).then(res => {
        const b = res.data || {}
        this.originalTaxes = {}
        ;(b.lines || []).forEach(line => {
          if (line.purchaseOrderLineId && line.tax != null && line.tax !== '') {
            this.originalTaxes[line.purchaseOrderLineId] = Number(line.tax)
          }
        })
        this.dataForm = {
          ...blankForm(),
          ...b,
          orderDate: (b.orderDate || '').slice(0, 10),
          lines: (b.lines || []).map(line => ({
            ...line,
            quantity: line.quantity != null ? Number(line.quantity) : null,
            price: line.price != null ? Number(line.price) : null,
            tax: line.tax != null && line.tax !== '' ? Number(line.tax) : null,
            receivedQuantity: Number(line.receivedQuantity || 0),
            deliveryDate: line.deliveryDate ? String(line.deliveryDate).slice(0, 10) : '',
            remark: line.remark || '',
            usableQuantity: null
          }))
        }
        this.tableKey += 1
        this.refreshLinesUsableQty()
      }).catch(() => {})
    },
    chooseSupplier(row) {
      this.dataForm.supplierId = row.supplierId
      this.dataForm.supplierName = row.supplierName
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.validateField('supplierId')
      })
    },
    addLine() {
      this.dataForm.lines.push({
        materialId: '', materialCode: '', materialName: '', specs: '',
        quantity: 1, receivedQuantity: 0, price: undefined, tax: undefined,
        deliveryDate: '', remark: '', amount: null, usableQuantity: null
      })
    },
    chooseMaterials(rows) {
      ;(rows || []).forEach(row => {
        const found = this.dataForm.lines.find(line => line.materialId === row.materialId)
        if (found) {
          found.quantity = Number(found.quantity || 0) + 1
          this.calcLineAmount(found)
        } else {
          this.dataForm.lines.push({
            materialId: row.materialId,
            materialCode: row.materialCode,
            materialName: row.materialName,
            specs: row.specs,
            quantity: 1,
            receivedQuantity: 0,
            price: row.price != null ? Number(row.price) : undefined,
            tax: row.tax != null && row.tax !== '' ? this.materialTax(row.tax) : undefined,
            deliveryDate: '',
            remark: '',
            amount: null,
            usableQuantity: row.usableQuantity != null ? Number(row.usableQuantity) : null
          })
          this.calcLineAmount(this.dataForm.lines[this.dataForm.lines.length - 1])
        }
      })
      this.refreshLinesUsableQty()
    },
    fillMaterialByCode(row) {
      if (!row.materialCode || !String(row.materialCode).trim()) return
      getMaterialByCode(String(row.materialCode).trim()).then(res => {
        const m = res.data
        if (!m) {
          this.$message.warning('产品编码不存在：' + row.materialCode)
          return
        }
        row.materialId = m.materialId
        row.materialCode = m.materialCode
        row.materialName = m.materialName
        row.specs = m.specs
        if (row.price == null && m.price != null) {
          row.price = Number(m.price)
          this.calcLineAmount(row)
        }
        if ((row.tax == null || row.tax === '') && m.tax != null && m.tax !== '') {
          row.tax = this.materialTax(m.tax)
        }
        this.refreshLineUsableQty(row)
      }).catch(() => {})
    },
    getLineQuantityMin(row) {
      if (!this.isEditMode || !row) return 0
      return Number(row.receivedQuantity || 0)
    },
    onLineQuantityChange(row) {
      if (this.isEditMode && row) {
        const min = this.getLineQuantityMin(row)
        if (row.quantity != null && Number(row.quantity) < min) {
          row.quantity = min
          this.$message.warning('订购数量不能小于已入库数量')
        }
      }
      this.calcLineAmount(row)
    },
    canDeleteLine(row) {
      return !(row && Number(row.receivedQuantity || 0) > 0)
    },
    removeLine(index, row) {
      if (!this.canDeleteLine(row)) {
        this.$message.warning('已有入库记录的明细行不允许删除')
        return
      }
      this.dataForm.lines.splice(index, 1)
    },
    calcLineAmount(row) {
      if (!row) return
      if (row.price != null && row.quantity != null) {
        row.amount = Number((Number(row.price) * Number(row.quantity)).toFixed(2))
      }
    },
    formatAmount(row) {
      if (!row) return ''
      if (row.amount != null && row.amount !== '') return row.amount
      if (row.price == null || row.quantity == null) return ''
      return Number((Number(row.price) * Number(row.quantity)).toFixed(2))
    },
    formatQty(val) {
      if (val == null || val === '') return '0'
      const n = Number(val)
      return Number.isNaN(n) ? '0' : n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    formatUsableQty(val) {
      if (val == null || val === '') return '-'
      const n = Number(val)
      if (Number.isNaN(n)) return '-'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    isLineUsableInsufficient(line) {
      if (!line || line.usableQuantity == null || line.usableQuantity === '') return false
      const need = Number(line.quantity || 0)
      const usable = Number(line.usableQuantity)
      return need > 0 && !Number.isNaN(usable) && need > usable
    },
    refreshLineUsableQty(line) {
      if (!line || !line.materialId) return Promise.resolve()
      return this.applyMaterialQtySumsToLines([line], [line.materialId])
    },
    refreshLinesUsableQty() {
      const lines = (this.dataForm.lines || []).filter(l => l && l.materialId)
      const materialIds = [...new Set(lines.map(l => l.materialId))]
      if (!materialIds.length) return Promise.resolve()
      return this.applyMaterialQtySumsToLines(lines, materialIds)
    },
    applyMaterialQtySumsToLines(lines, materialIds) {
      return request.post('/inventory/quantity/usableSums', { materialIds }).then(res => {
        const sums = res.data || {}
        lines.forEach(line => {
          if (!line || !line.materialId) return
          const uq = sums[line.materialId]
          this.$set(line, 'usableQuantity', uq == null ? 0 : uq)
        })
      }).catch(() => {})
    },
    validateLines() {
      const taxes = (this.taxList || []).map(item => Number(item.dictValue))
      for (let i = 0; i < this.dataForm.lines.length; i++) {
        const line = this.dataForm.lines[i]
        const rowNo = i + 1
        if (!line.materialCode || !String(line.materialCode).trim()) {
          return `第${rowNo}行：产品编码不能为空`
        }
        if (line.quantity == null || Number(line.quantity) <= 0) {
          return `第${rowNo}行：订购数量必须大于0`
        }
        if (this.isEditMode) {
          const received = Number(line.receivedQuantity || 0)
          if (Number(line.quantity) < received) {
            return `第${rowNo}行：订购数量不能小于已入库数量`
          }
        }
        if (line.price == null || line.price === '') {
          return `第${rowNo}行：含税单价不能为空`
        }
        if (line.tax == null || line.tax === '') {
          return `第${rowNo}行：税点不能为空`
        }
        const originalTax = this.originalTaxes[line.purchaseOrderLineId]
        if (taxes.length && taxes.indexOf(Number(line.tax)) < 0 && Number(line.tax) !== originalTax) {
          return `第${rowNo}行：税点字典项无效，请重新选择`
        }
        if (!line.deliveryDate) {
          return `第${rowNo}行：交货日期不能为空`
        }
      }
      return ''
    },
    submitHandle() {
      if (!this.dataForm.lines.length) {
        this.$message.error('请至少维护一条明细')
        return
      }
      const lineErr = this.validateLines()
      if (lineErr) {
        this.$message.error(lineErr)
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = {
          ...this.dataForm,
          orderDate: this.dataForm.orderDate ? String(this.dataForm.orderDate).slice(0, 10) : null,
          lines: this.dataForm.lines.map(line => ({
            ...line,
            tax: line.tax != null && line.tax !== '' ? Number(line.tax) : null,
            deliveryDate: line.deliveryDate ? String(line.deliveryDate).slice(0, 10) : null,
            remark: line.remark || '',
            amount: Number((Number(line.price || 0) * Number(line.quantity || 0)).toFixed(2))
          }))
        }
        const url = '/purchase/purchaseOrder/' + (this.dataForm.purchaseOrderId ? 'update' : 'save')
        request.post(url, payload).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    confirmHandle() {
      this.$confirm('确认后将不可修改订单，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionLoading = true
        request.post('/purchase/purchaseOrder/confirm', { purchaseOrderId: this.dataForm.purchaseOrderId }).then(() => {
          this.$message.success('确认成功')
          this.$emit('refreshDataList')
          this.loadDetail(this.dataForm.purchaseOrderId)
          this.readonly = true
        }).catch(() => {}).finally(() => { this.actionLoading = false })
      }).catch(() => {})
    },
    unconfirmHandle() {
      this.$confirm('反确认后订单恢复为开立状态，可再次修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionLoading = true
        request.post('/purchase/purchaseOrder/unconfirm', { purchaseOrderId: this.dataForm.purchaseOrderId }).then(() => {
          this.$message.success('反确认成功')
          this.$emit('refreshDataList')
          this.loadDetail(this.dataForm.purchaseOrderId)
          this.readonly = true
        }).catch(() => {}).finally(() => { this.actionLoading = false })
      }).catch(() => {})
    },
    deleteHandle() {
      this.$confirm('确定删除该采购订单?', '提示', { type: 'warning' }).then(() => {
        this.actionLoading = true
        request.post('/purchase/purchaseOrder/delete', { purchaseOrderId: this.dataForm.purchaseOrderId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionLoading = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.purchases-order-qty-warn {
  color: #e6a23c;
  font-weight: 600;
}
.doc-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 40px;
}
.doc-dialog-title {
  font-size: 16px;
  font-weight: 600;
}
</style>
